const SITE_URL = 'https://lmf.lvmifo.com'
const SITE_NAME = '绿蜜蜂旧衣服回收'
const DEFAULT_TITLE = '绿蜜蜂旧衣服回收 - 免费上门环保回收平台'
const DEFAULT_DESCRIPTION = '绿蜜蜂旧衣服回收支持顺丰免费上门取件，最快2小时上门，全程免费，旧衣服可换现金、换礼品，并助力爱心公益。'
const DEFAULT_KEYWORDS = '绿蜜蜂,旧衣服回收,旧书回收,家电回收,电子杂物回收,手机回收,家具清运,顺丰免费上门取件,最快2小时上门,旧衣服换现金,旧衣服换礼品,爱心公益'
const LOGO_URL = 'https://lmf.lvmifo.com/static/upload/H5/096927ac9ad98f2e.png'
const RECYCLE_CATEGORY_DESCRIPTION = '支持回收旧衣、旧书、家电、电子杂物、手机数码和家具清运。旧衣包括四季衣物、各类鞋靴、闲置旧包、帽子围巾、床单被罩、毛绒玩具；旧书包括人文社科、文学小说、大学教材、生活艺术、儿童绘本；家电包括空调、冰箱、洗衣机、电视机、电动车；电子杂物包括微波炉、电烤箱、电饭煲、吸尘器、电饼铛、电磁炉、电水壶等；手机数码包括手机、平板、智能手表、电脑、相机；家具清运包括沙发桌椅、床、健身器材、柜子。'

const pageSchemas = new Map()

function ensureHeadTag(selector, createTag) {
    let tag = document.head.querySelector(selector)
    if (!tag) {
        tag = createTag()
        document.head.appendChild(tag)
    }
    return tag
}

function setMeta(name, content) {
    if (!content) return
    const tag = ensureHeadTag(`meta[name="${name}"]`, () => {
        const meta = document.createElement('meta')
        meta.setAttribute('name', name)
        return meta
    })
    tag.setAttribute('content', content)
}

function setProperty(property, content) {
    if (!content) return
    const tag = ensureHeadTag(`meta[property="${property}"]`, () => {
        const meta = document.createElement('meta')
        meta.setAttribute('property', property)
        return meta
    })
    tag.setAttribute('content', content)
}

function setCanonical(url) {
    const tag = ensureHeadTag('link[rel="canonical"]', () => {
        const link = document.createElement('link')
        link.setAttribute('rel', 'canonical')
        return link
    })
    tag.setAttribute('href', url)
}

function removePageSchemas() {
    pageSchemas.forEach((tag) => {
        if (tag.parentNode) {
            tag.parentNode.removeChild(tag)
        }
    })
    pageSchemas.clear()
}

export function getCanonicalUrl(path = '/') {
    const cleanPath = path.startsWith('/') ? path : `/${path}`
    return `${SITE_URL}${cleanPath === '/p_index' ? '/' : cleanPath}`
}

export function stripHtml(html = '') {
    return String(html)
        .replace(/<script[\s\S]*?<\/script>/gi, '')
        .replace(/<style[\s\S]*?<\/style>/gi, '')
        .replace(/<[^>]+>/g, '')
        .replace(/\s+/g, ' ')
        .trim()
}

export function buildDescription(text = '', fallback = DEFAULT_DESCRIPTION) {
    const plainText = stripHtml(text)
    return (plainText || fallback).slice(0, 150)
}

export function applySeo(meta = {}, routePath = '/') {
    if (typeof document === 'undefined') return

    const title = meta.title || DEFAULT_TITLE
    const description = meta.description || DEFAULT_DESCRIPTION
    const keywords = meta.keywords || DEFAULT_KEYWORDS
    const canonical = meta.canonical || getCanonicalUrl(meta.canonicalPath || routePath)

    document.title = title
    setMeta('description', description)
    setMeta('keywords', keywords)
    setMeta('robots', meta.robots || 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1')
    setProperty('og:type', meta.ogType || 'website')
    setProperty('og:site_name', SITE_NAME)
    setProperty('og:title', title)
    setProperty('og:description', description)
    setProperty('og:url', canonical)
    setCanonical(canonical)

    removePageSchemas()
    if (meta.schemas) {
        addJsonLd(meta.schemas)
    }
}

export function addJsonLd(schemas = []) {
    if (typeof document === 'undefined') return
    const schemaList = Array.isArray(schemas) ? schemas : [schemas]
    schemaList.filter(Boolean).forEach((schema, index) => {
        const script = document.createElement('script')
        script.type = 'application/ld+json'
        script.dataset.seoSchema = String(index)
        script.textContent = JSON.stringify(schema)
        document.head.appendChild(script)
        pageSchemas.set(index, script)
    })
}

export function organizationSchema() {
    return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: SITE_NAME,
        url: SITE_URL,
        logo: LOGO_URL,
        email: 'lvmifo@163.com',
        telephone: '400-887-6885',
        description: DEFAULT_DESCRIPTION,
        brand: {
            '@type': 'Brand',
            name: '绿蜜蜂'
        }
    }
}

export function websiteSchema() {
    return {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: SITE_NAME,
        url: SITE_URL,
        description: DEFAULT_DESCRIPTION,
        potentialAction: {
            '@type': 'SearchAction',
            target: `${SITE_URL}/p_new?keyword={search_term_string}`,
            'query-input': 'required name=search_term_string'
        }
    }
}

export function serviceSchema() {
    return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: '旧衣服免费上门回收服务',
        provider: organizationSchema(),
        areaServed: '中国主要城市',
        serviceType: '环保回收服务',
        description: `绿蜜蜂提供多品类环保回收，支持顺丰免费上门取件，最快2小时上门，全程免费，旧衣服可换现金、换礼品，并助力爱心公益。${RECYCLE_CATEGORY_DESCRIPTION}`,
        hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: '绿蜜蜂回收品类',
            itemListElement: [
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '旧衣回收', description: '四季衣物、各类鞋靴、闲置旧包、帽子围巾、床单被罩、毛绒玩具' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '旧书回收', description: '人文社科、文学小说、大学教材、生活艺术、儿童绘本' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '家电回收', description: '空调、冰箱、洗衣机、电视机、电动车' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '电子杂物回收', description: '微波炉、电烤箱、电饭煲、吸尘器、电饼铛、电磁炉、电水壶等' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '手机回收', description: '手机、平板、智能手表、电脑、相机' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '家具清运', description: '沙发桌椅、床、健身器材、柜子' } }
            ]
        },
        offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'CNY',
            description: '全程免费，支持顺丰免费上门取件，旧衣服可换现金或礼品'
        }
    }
}

export function faqSchema() {
    const questions = [
        ['绿蜜蜂回收平台是否免费上门？', '绿蜜蜂回收平台支持顺丰免费上门取件，旧衣、旧书、家电、电子杂物、手机数码、家具清运等多品类回收全程免费，用户可按页面指引通过支付宝生活号、微信公众号或小程序参与回收。'],
        ['绿蜜蜂最快多久可以上门？', '绿蜜蜂回收平台最快2小时上门，具体上门时间以预约地址、服务时段和顺丰取件安排为准。'],
        ['参与回收可以获得什么？', '用户参与绿蜜蜂回收平台，可按活动规则获得现金奖励、礼品兑换或环保能量等权益，旧衣回收还可换现金、换礼品。'],
        ['绿蜜蜂回收是否支持公益？', '绿蜜蜂回收平台助力爱心公益，通过旧衣、旧书等多品类环保回收和公益行动，让闲置物品持续产生社会价值。'],
        ['绿蜜蜂支持回收哪些品类？', '绿蜜蜂支持旧衣回收、旧书回收、家电回收、电子杂物回收、手机回收和家具清运，覆盖衣物鞋靴、书籍教材、家电数码、沙发桌椅等多类闲置物品。']
    ]

    return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: questions.map(([name, text]) => ({
            '@type': 'Question',
            name,
            acceptedAnswer: {
                '@type': 'Answer',
                text
            }
        }))
    }
}

export function breadcrumbSchema(items = []) {
    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            item: getCanonicalUrl(item.path)
        }))
    }
}

export function articleSchema(article = {}) {
    const title = article.title || '绿蜜蜂平台资讯'
    const description = buildDescription(article.explain || article.content, '绿蜜蜂平台资讯，分享顺丰免费上门取件、旧衣服换现金礼品、爱心公益、环保回收和循环经济相关内容。')

    return {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: title,
        description,
        image: article.images || LOGO_URL,
        datePublished: article.release_time || undefined,
        author: organizationSchema(),
        publisher: organizationSchema(),
        mainEntityOfPage: getCanonicalUrl('/p_newDetail')
    }
}

export const seoDefaults = {
    siteUrl: SITE_URL,
    siteName: SITE_NAME,
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    keywords: DEFAULT_KEYWORDS
}
